import React, { useContext } from 'react';
import path from 'path-browserify';
import slugify from 'slugify';
import { FormattedDate } from 'react-intl';
import { Link } from 'gatsby';
import { ChevronRight } from 'react-feather';

import { PageContext } from '../../PageContext';
import Button from '../../Button/Button';
import Divider from '../../Divider';
import { EventsCtaFragment, EventFragment } from '../../../../graphql.schema';

import * as styles from './index.module.scss';

export type EventCTAPanelType = EventsCtaFragment & {
  linkedEvents: EventFragment[];
  slugBase: string;
  linkText: string;
};
export const StrapiEventCTAPanel = ({
  panelTitle,
  eventLinkText,
  eventLinkUrl,
  eventCalendarText,
  eventCalendarUrl,
  linkedEvents,
  slugBase,
  linkText,
}: EventCTAPanelType) => {
  const context = useContext(PageContext);
  return (
    <div className={styles.eventCtaWrapper} data-testid="event-cta-wrapper">
      <h2 className="title is-2 brand-a">{panelTitle}</h2>
      <div>
        <Link to={eventLinkUrl ?? ''} className="is-inline-flex is-text-2 link-spacing has-text-weight-bold mr-5">
          {eventLinkText}
          <span className="icon black-3">
            <ChevronRight size={16} />
          </span>
        </Link>
        <Link to={eventCalendarUrl ?? ''} className="is-inline-flex is-text-2 link-spacing has-text-weight-bold">
          {eventCalendarText}
          <span className="icon black-3">
            <ChevronRight size={16} />
          </span>
        </Link>
      </div>
      <Divider paddingTop="40px" marginBottom="45px" />
      <div className="columns">
        {linkedEvents.length > 0 && (
          linkedEvents.map(({ title, slug, eventTime, eventAddress }) => (
            <div className="column" key={title}>
              <time className={`is-5 title mb-1 black-3`} dateTime={eventTime}>
                <FormattedDate
                  value={eventTime}
                  weekday="short"
                  month="short"
                  day="2-digit"
                  hour="2-digit"
                  minute="2-digit"
                />
              </time>

              <Link
                to={path.join(slugBase, slug ?? slugify(title, { lower: true, strict: true }))}
                className="title is-block is-3 brand-a mt-0 mb-3"
              >
                {title}
              </Link>
              <p className="is-text-2 black-2 mb-5">{eventAddress}</p>
              <div className="read-more">
                <Button
                  type="secondary"
                  href={path.join(context.pathPrefixes.events, slug ?? slugify(title, { lower: true, strict: true }))}
                  className="is-inline-flex is-text-2 link-spacing"
                >
                  {linkText}
                </Button>
              </div>
            </div>
          ))) 
            }
      </div>
    </div>
  );
};

export default StrapiEventCTAPanel;
